import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import cx from "classnames";
import _ from "lodash";
import bingoLogo from "../../assets/images/bingo/heyLimeLogo.png";
import slidekickLogo from "../../assets/images/slideKick/heyLimeLogo.png";
import heyLimeLogo from "../../assets/images/heyLimeLogo.png";
import Vector from "../../assets/images/bingo/Vector.png";
import backArrow from "../../assets/images/signin/back-arrow.png";
import hamburgerMenu from "../../assets/images/hamburger-menu.png";
import { set_header_drop_down } from "redux/game/action";
import TwDropdown from "./TwDropdown";
import CTHeader from "./CTHeader";
import CHPTHeader from "./CHPTHeader";

function Header({
  history,
  onLogout,
  gameName,
  handle_leave_game,
  toggle_how_to_play,
  handle_leave_session,
  handle_help_click,
  ...props
}) {
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    gameReducer: { header_drop_down, currentUser,
      roomObj:{
        users,
        game_state:{
          status,player_hands
        }= {}

      }
    
    }
  } = useSelector((state) => state);

  const [dropdown_disabled, set_dropdown_disabled] = useState(false);
  useEffect(() => {
    if (location.pathname.includes("leave-game")) {
      set_dropdown_disabled(true);
    } else {
      set_dropdown_disabled(false);
    }
  }, [location.pathname]);

  const params = _.get(props, "paramsReducer.gameObj.joining");
  const [show_dropdown, set_show_dropdown] = useState(false);

  const toggle_dropdown = () => {
    dispatch(set_header_drop_down(!header_drop_down));
  };
  const getApp = () => {
    window.open(`https://gameapart.app.link/fS3QgiWSdob`);
  };

  const gameNameSbs = () => {
    return (
      gameName === "LT" ||
      gameName === "LTS" ||
      gameName === "CC" ||
      gameName === "CCS" ||
      gameName === "TTL" ||
      gameName === "TOT" ||
      gameName === "TOTO" ||
      gameName === "WELL" ||
      gameName === "GAH" ||
      gameName === "VB" ||
      gameName === "TW" ||
      gameName === "FLUS" ||
      gameName === "DW20" ||
      gameName === "CT" ||
      gameName === "OCH" 
    );
  };

  return (
    <div className="nav">
      <div
        id="nav-header"
        className={cx(`${gameName}`, {
          homepage: location.pathname === "/"
        })}
      >
        {location.pathname === "/conspiracy_theory" ? (
          <CTHeader
            currentUser={currentUser}
            toggle_dropdown={toggle_dropdown}
          />
        ) :location.pathname === "/charty_party" ?<>
         <CHPTHeader 
         toggle_dropdown={toggle_dropdown}
         currentUser={currentUser}
         status={status}
         PlayerGameInfo={player_hands}
         users={users}
         />
         
         </>: (
          <>
            <div className="flex1">
              {gameName === "BNG" ? (
                <button
                  className="btn info-icon"
                  onClick={toggle_how_to_play}
                  disabled={dropdown_disabled}
                >
                  <img src={Vector} alt="vectorIcon" />
                </button>
              ) : gameNameSbs() ? (
                gameName === "LT" ||
                gameName === "LTS" ||
                gameName === "CC" ||
                gameName === "CCS" ||
                gameName === "VB" ||
               
                gameName === "TTL" ? (
                  <></>
                ) : gameName === "WELL" ? (
                  <img
                    alt=""
                    onClick={() => history.replace("/")}
                    src={backArrow}
                  />
                ) : (
                  <button
                    className="btn info-icon"
                    onClick={toggle_how_to_play}
                  >
                    <img src={Vector} alt="vectorIcon" />
                  </button>
                )
              ) : location.pathname === "/challenges" ? (
                <img alt="" src={backArrow} onClick={() => history.push("/")} />
              ) : location.pathname.includes("challenge") ? (
                <img alt="" src={backArrow} onClick={() => history.goBack()} />
              ) : !location.pathname.includes("lobby") ? (
                <button className="btn btn-get-app" onClick={() => getApp()}>
                  {params?.get_the_app_label || "Get The App"}
                </button>
              ) : (
                <img
                  alt=""
                  onClick={() => {
                    dispatch(set_header_drop_down(false));

                    handle_leave_session();
                  }}
                  src={backArrow}
                />
              )}
            </div>
            <div className="flex2">
              <img
                className="logo"
                src={
                  location.pathname === "/"
                    ? heyLimeLogo
                    : gameName === "BNG"
                    ? bingoLogo
                    : gameName === "SK"
                    ? heyLimeLogo
                    : gameNameSbs()
                    ? gameName === "WELL"
                      ? heyLimeLogo
                      : slidekickLogo
                    : heyLimeLogo
                }
                alt="logo"
              />
            </div>
            <div className="flex3">
              {!dropdown_disabled &&
                !location.pathname.includes("challenge") && (
                  <img alt="" src={hamburgerMenu} onClick={toggle_dropdown} />
                )}
            </div>
          </>
        )}
      </div>
      {gameNameSbs() && <div className="borderBottom" />}

      {header_drop_down &&
        (location.pathname === "/the_word" ||
        location.pathname === "/done_with_2020" ||
        location.pathname === "/fluster" ||  location.pathname === "/ochos_locos" || location.pathname === "/charty_party"? (
          <TwDropdown
            handle_leave_game={handle_leave_game}
            onLogout={onLogout}
            toggle_dropdown={toggle_dropdown}
            toggle_how_to_play={toggle_how_to_play}
            handle_help_click={handle_help_click}
            isFlusterHeader={location.pathname === "/fluster"}
            isDw20Header={location.pathname === "/done_with_2020"}
            isChartypartyHeader={location.pathname === "/charty_party"}
            isOchosLocosHeader={location.pathname === "/ochos_locos"}

          />
        ) : (
          <>
            {location.pathname === "/" ? (
              <div
                onClick={() => {
                  toggle_dropdown();
                  onLogout();
                }}
                className="dropdown-container"
              >
                Logout
              </div>
            ) : location.pathname === "/lobby" ? (
              <div
                onClick={() => {
                  toggle_dropdown();
                  handle_leave_session();
                }}
                className="dropdown-container"
              >
                Leave Session
              </div>
            ) : (
              <div
                onClick={() => {
                  toggle_dropdown();
                  handle_leave_game();
                }}
                className="dropdown-container"
              >
                Leave Game
              </div>
              // <div className={`dropdown ${gameName}`}>
              //   <div
              //     className="dropdown-item text-light"
              //     onClick={() => {
              //       toggle_dropdown();
              //       handle_leave_game();
              //     }}
              //   >
              //     leave game
              //   </div>
              // </div>
            )}
          </>
        ))}
    </div>
  );
}

export default Header;
